import { z } from 'zod'

export const UpsertContentInputZ = z.object({
  markdown: z.object({
    id: z.string().uuid().optional(),
    content: z.string().min(1, 'Content is required')
  }),
  attachments: z
    .array(
      z.object({
        id: z.string().uuid().optional(),
        name: z.string().min(1, 'Name is required'),
        url: z.string().min(1, 'URL is required')
      })
    )
    .optional()
})

export type UpsertContentInput = z.infer<typeof UpsertContentInputZ>
